module.exports = __webpack_public_path__ + "static/media/Golem_gaussian2.43ab5cc0.png";